<template>
  <div class="p-lg">
    <h1>Embeddable Registration Widget</h1>
    <div class="mb-lg" style="width: 600px;">
      <h2>Default options</h2>
      <div
        data-register-widget
        data-submit-button-text="Sign up!"
        data-campaign="testing"
        data-country-code="gb">
      </div>
    </div>
    <div class="mb-lg" style="width: 600px;">
      <h2>German locale, no phone</h2>
      <div
        data-register-widget
        data-campaign="testing"
        data-locale="de"
        data-display-phone="false"
        data-country-code="de">
      </div>
    </div>
  </div>
</template>

<script>
import external from '@/utils/external';

export default {
  mounted() {
    external.injectScript('/-/sync-cookies.js');
    external.injectScript('/-/embeddable-registration.js');
  },
};
</script>

<style scoped>
/* @import url('https://www.signable.co.uk/wp-content/cache/autoptimize/css/autoptimize_a6a93b89442335ffa0dead57b7647f0c.css'); */
</style>
